const authRoutes = {
  Login: () => '/login',
  Signup: () => '/signup',
  SignupV2: () => '/get-started',
  ForgotPassword: () => '/forgot-password',
  SetPassword: () => '/set-password',
  VerifyEmail: () => '/verify-email',
  VerifyEmailV2: () => '/verify-email-v2',
  VerifyYourself: () => '/verify-yourself',
  EmailLogin: () => '/email-login',
  EmailSignup: () => '/email-signup',
};

export default authRoutes;
